import { useReportForm } from 'modules/reports/hooks/useReportFormContext';
import styles from './report-period.module.scss';

const investmentReportOptions = [
  'Balance summary',
  'Fund allocation',
  'Exposure',
  'Recurring investment',
  'Contributions',
  'Nominees',
  'Regular withdrawal',
  'Fund detail statement',
  'Transaction detail statement',
  'Transaction summary',
  'Investment value graph',
  'Contributions and withdrawals',
  'Fund growth statement',
  'Effective annual cost',
  'Policy value detail',
  'Internal rate of return',
  'Risk cover statement',
  'Income'
];

const investmentOverviewOptions = [
  'Portfolio summary',
  'Performance breakdown',
  'Asset allocation',
  'Sector exposure',
  'Dividend history',
  'Risk analysis',
  'Historical returns'
];

export const SelectReportOptions = () => {
  const { formData, updateFormData, toggleOption, clearSelections } = useReportForm();

  const handleReportTypeChange = (type: 'investmentReport' | 'investmentOverview') => {
    updateFormData({ reportType: type, selectedOptions: [] });
  };

  const reportOptions =
    formData.reportType === 'investmentReport'
      ? investmentReportOptions
      : investmentOverviewOptions;

  return (
    <div className={styles.container}>
      <h3>Customize your report</h3>
      <div className={styles.reportTypeSelection}>
        <label>
          <input
            type='radio'
            name='reportType'
            value='investmentReport'
            checked={formData.reportType === 'investmentReport'}
            onChange={() => handleReportTypeChange('investmentReport')}
          />
          Investment Report
        </label>
        <label>
          <input
            type='radio'
            name='reportType'
            value='investmentOverview'
            checked={formData.reportType === 'investmentOverview'}
            onChange={() => handleReportTypeChange('investmentOverview')}
          />
          Investment Overview
        </label>
      </div>

      <h4 className={styles.sectionTitle}>
        What should the{' '}
        {formData.reportType === 'investmentReport' ? 'Investment Report' : 'Investment Overview'}{' '}
        show?
      </h4>
      <button onClick={clearSelections} className={styles.clearButton}>
        Clear all selections
      </button>

      <div className={styles.optionsGrid}>
        {reportOptions.map((option) => (
          <label key={option} className={styles.option}>
            <input
              type='checkbox'
              checked={formData.selectedOptions.includes(option)}
              onChange={() => toggleOption(option)}
            />
            {option}
          </label>
        ))}
      </div>
    </div>
  );
};
